/*
  Cart drawer "(Save €X)" label — Sableau
  ------------------------------------------------------------
  The Essential Cart Drawer already renders a struck-through compare-at
  price and the sale price per line item. This script appends a green
  "(Save €X)" right after the sale price, computed from the two amounts
  that are already on screen, so it works in every market currency
  (EUR, SEK, NOK, DKK, GBP, ...) and re-applies after each drawer re-render.

  Scope: the drawer's own markup via its stable data-essential-cart-element
  hooks (line-item-regular-price / line-item-discounted-price).
*/
(function () {
  if (window.__sbCartSavingsLoaded) return;
  window.__sbCartSavingsLoaded = true;

  var STYLE = '.sb-save{color:#0a8a4a;font-weight:600;font-size:.85em;margin-left:.35em;white-space:nowrap}';

  // "€199,99" · "kr 1.113,07" · "1 113,07 kr" · "£85.00" · "SEK 1 158,00"
  var PRICE_RE = /^\s*(?:[^\d\s]{0,4}\s?)?\d[\d.,\s ]*(?:\s?[^\d\s]{0,4})?\s*$/;

  function leafText(el) {
    if (el.children.length) return null;
    var t = (el.textContent || '').replace(/ /g, ' ').trim();
    if (!t || t.length > 24 || !/\d/.test(t) || !PRICE_RE.test(t)) return null;
    return t;
  }

  function parseCents(str) {
    var num = str.replace(/[^\d.,]/g, '');
    var m = num.match(/^(.*?)([.,])(\d{2})$/);
    var intPart = (m ? m[1] : num).replace(/[.,]/g, '');
    var dec = m ? m[3] : '00';
    if (!intPart && !m) return null;
    return { cents: parseInt(intPart || '0', 10) * 100 + parseInt(dec, 10), decSep: m ? m[2] : null };
  }

  function formatLike(sample, cents) {
    var m = sample.match(/^(\D*?)(\d[\d.,\s ]*\d|\d)(\D*)$/);
    if (!m) return null;
    var prefix = m[1], numStr = m[2], suffix = m[3];
    var parsed = parseCents(numStr);
    var decSep = (parsed && parsed.decSep) || (numStr.indexOf(',') >= 0 ? ',' : '.');
    var thouSep = '';
    var head = numStr.replace(/[.,]\d{2}\s*$/, '');
    var t = head.match(/[.,\s ]/);
    if (t) thouSep = t[0];
    var whole = Math.floor(cents / 100);
    var frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;
    var ws = String(whole);
    if (thouSep) ws = ws.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return prefix + ws + decSep + frac + suffix;
  }

  var ITEM = '[data-essential-cart-element="cart-drawer-item"]';
  var REG = '[data-essential-cart-element="line-item-regular-price"]';
  var DISC = '[data-essential-cart-element="line-item-discounted-price"]';
  var PROPS = '[data-essential-cart-element="line-item-properties"]';

  function apply() {
    // 1) "(Save €X)" after the discounted price of every drawer line item.
    var items = document.querySelectorAll(ITEM);
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var reg = item.querySelector(REG);
      var disc = item.querySelector(DISC);
      if (!reg || !disc) continue;
      var regTxt = leafText(reg) || (reg.textContent || '').trim();
      var discTxt = leafText(disc) || (disc.textContent || '').trim();
      var a = parseCents(regTxt), b = parseCents(discTxt);
      var existing = disc.parentElement && disc.parentElement.querySelector(':scope > .sb-save');
      if (!a || !b || a.cents <= b.cents) { if (existing) existing.remove(); continue; }
      var label = formatLike(discTxt, a.cents - b.cents);
      if (!label) continue;
      var text = '(Save ' + label + ')';
      if (existing) { if (existing.textContent !== text) existing.textContent = text; continue; }
      var span = document.createElement('span');
      span.className = 'sb-save';
      span.textContent = text;
      disc.parentElement.insertBefore(span, disc.nextSibling);
    }
    // 2) The "You save" line-item property (added for the checkout) would print here as
    //    grey text under the title; the green label already covers it in the drawer.
    var props = document.querySelectorAll(PROPS);
    for (var j = 0; j < props.length; j++) {
      var p = props[j];
      if (p.__sbHidden) continue;
      if (/You save\s*:/.test(p.textContent || '')) { p.style.display = 'none'; p.__sbHidden = true; }
    }
  }

  window.__sbCartSavingsApply = apply;

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; try { apply(); } catch (e) {} }, 150);
  }

  function start() {
    var css = document.createElement('style');
    css.textContent = STYLE;
    (document.head || document.documentElement).appendChild(css);
    schedule();
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    // Drawer content is injected late / on open; a few timed passes catch it.
    var n = 0;
    var timer = setInterval(function () { schedule(); if (++n > 20) clearInterval(timer); }, 1000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/*
  Het tweede blok ("✅ You save"-regeleigenschap via fetch/XHR-onderschepping, met een
  /variants/{id}.js-rondje vóór élke add-to-cart) is 10-09-2026 verwijderd: het kostte tijd op de knop
  waar de omzet begint, en het dubbelde met het groene label hierboven.

  LET OP (bijgewerkt 12-09-2026): de oude reden erbij — "sinds 02-09 heeft geen enkel product nog een
  compare-at-prijs" — geldt niet meer. Op 10-09 staat compare_at weer op 54 producten (sale-anker, ADR
  0016). Het groene "(Save €X)"-label hierboven doet dus weer écht werk; het is geen dode code. Wie hier
  iets weghaalt omdat "er toch geen kortingen zijn", sloopt een levend label.
*/
